/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path axios
 * @description Axios interceptor: reset session on 401.
 */
import axios, { AxiosInstance } from "axios";
import apiSessionStorage from "../apicaller/api-session-storage";

/** Add 401 handling to any axios instance. Use for default axios and every axios.create(). */
export function addSessionExpiredInterceptor(instance: AxiosInstance): void {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        apiSessionStorage.destroySession();
        window.location.reload();
      }
      return Promise.reject(error);
    }
  );
}

export default {
  setupInterceptors: () => {
    addSessionExpiredInterceptor(axios);
  },
};
